import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import environment from '@/environment';
import {getDefaultLocale} from '@/utils/i18n';
import englishResources from '../assets/locales/en/common.json';
import frenchResources from '../assets/locales/fr/common.json';

export const ENGLISH_LOCALE = 'en' as const;
export const FRENCH_LOCALE = 'fr' as const;

export const SUPPORTED_LOCALES: SupportedLocale[] = [ENGLISH_LOCALE, FRENCH_LOCALE];

export type SupportedLocale = typeof ENGLISH_LOCALE | typeof FRENCH_LOCALE;

const preload = SUPPORTED_LOCALES; // Frequent that advisors need both, and it simplifies Suspense handling

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    debug: environment.DEBUG,
    supportedLngs: SUPPORTED_LOCALES,
    lng: getDefaultLocale(SUPPORTED_LOCALES, FRENCH_LOCALE),
    preload,
    fallbackLng: ENGLISH_LOCALE,
    defaultNS: 'common',
    ns: ['common'],
    returnNull: false,
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    resources: {
      en: {common: englishResources},
      fr: {common: frenchResources},
    },
  });

export default i18n;
